module.exports = "<p>\r\n  registro-minorista works!\r\n</p>\r\n"